import { PrimaryRoleRepeaterWidget } from '../primary-role-repeater-widget/primary-role-repeater-widget';
import editForm from './co-borrower-entity.form';
import { CustomComponentType, CustomBuilderGroups, LoanRoleType } from '../../../enums';

export default class CoBorrowerEntityWidget extends PrimaryRoleRepeaterWidget {
	static schema(...extend: any) {
		return PrimaryRoleRepeaterWidget.schema(
			{
				label: 'Co-Borrower',
				type: CustomComponentType.coBorrowerEntity,
				key: CustomComponentType.coBorrowerEntity,
				addAnother: 'Add a Co-Borrower'
			},
			...extend
		);
	}

	static editForm = editForm;

	static get builderInfo() {
		return {
			title: 'Co-Borrower',
			group: CustomBuilderGroups.widgets,
			weight: 10,
			schema: CoBorrowerEntityWidget.schema({
				skipRemoveConfirm: true
			})
		};
	}

	init() {
		this.roleType = LoanRoleType.CoBorrower;

		super.init();
	}
}
